// src/utils/auth.js

const ACCESS_KEY = "accessToken";
const REFRESH_KEY = "refreshToken";
const LOGGED_KEY = "isLoggedIn";

// DRF Token kullanıyoruz → Authorization: Token <key>
function setAuthHeader(token) {
  try {
    const axiosInstance = require("../utils/axiosInstance").default;
    if (token) axiosInstance.defaults.headers.common["Authorization"] = `Token ${token}`;
    else delete axiosInstance.defaults.headers.common["Authorization"];
  } catch {}
}

export function setToken(token, refreshToken = null) {
  if (typeof token === "string" && token.length > 0) {
    localStorage.setItem(ACCESS_KEY, token);
    if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
    localStorage.setItem(LOGGED_KEY, "1");
    setAuthHeader(token);
  } else {
    clearToken();
    return;
  }
  window.dispatchEvent(new Event("auth:change"));
}

export function getToken() {
  return localStorage.getItem(ACCESS_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_KEY);
}

export function clearToken() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(LOGGED_KEY);
  localStorage.removeItem("profile_role");
  localStorage.removeItem("profile_can_post");
  localStorage.removeItem("profile_can_analyze");
  setAuthHeader(null);
  window.dispatchEvent(new Event("auth:change"));
}

// ✅ DRF token'da JWT exp yok → token varsa logged-in say
export function isLoggedIn() {
  const token = localStorage.getItem(ACCESS_KEY);
  return !!token;
}

export const setLoggedIn = () => {
  localStorage.setItem(LOGGED_KEY, "1");
  window.dispatchEvent(new Event("auth:change"));
};

export const setLoggedOut = () => {
  clearToken();
};

// Role/can_post/can_analyze
export function setProfile({ role = null, can_post = false, can_analyze = false } = {}) {
  if (role) localStorage.setItem("profile_role", role);
  else localStorage.removeItem("profile_role");

  localStorage.setItem("profile_can_post", can_post ? "1" : "0");
  localStorage.setItem("profile_can_analyze", can_analyze ? "1" : "0");

  window.dispatchEvent(new Event("auth:change"));
}

// Uygulama ilk açıldığında header hazır olsun
(function bootstrapAuthHeader() {
  try {
    const token = localStorage.getItem(ACCESS_KEY);
    if (token) setAuthHeader(token);
  } catch {}
})();